import { newID } from '../../src/helpers/studioApi';
let mode = 'remoteserver'; // 'localserver' 'remoteserver' 'noserver'
// let domain = mode === 'localserver' ? 'http://localhost:1337/' : 'https://api.superteach.org/';
let domain = mode === 'localserver' ? 'http://localhost:1337/' : 'https://apilw.html5.run/';
const elemid = newID('element');
const sldid = newID('slide');
const hostName = window?.location?.hostname;
const subDomainsLength = hostName && hostName !== 'localhost' ? hostName?.split('.')?.length : 0;
const cookiesDoamin = !subDomainsLength
    ? null
    : `lifewise.co.uk`;

let appConfig = {
    socketURL: domain,
    imageUrl: domain,
    count: domain + 'api/',
    collection: domain + 'api',
    studioLink: '/studio/',
    projects: domain + 'api/projects',
    resources: domain + 'api/resources',
    schools: domain + 'api/schools',
    templates: domain + 'api/templates',
    loginUrl: domain + 'api/auth/local',
    register: domain + 'api/auth/local/register',
    users: domain + 'api/users',
    assets: domain + 'api/assets',
    svgs: domain + 'api/svgs',
    overlays: domain + 'api/overlays',
    upload: domain + 'api/upload',
    publisheds: domain + 'api/publisheds',
    player: 'https://stplr.superteach.org/',
    theme: domain + 'api/themes',
    ['slide-templates']: domain + 'api/slide-templates',
    cookiesDoamin,
    createWithAi: 'https://aibdev.gnx.sh/api/v1/pipeline/studio-presentation-maker',
    createAi: 'https://aibdev.gnx.sh/api/v1/pipeline/create-presentation-plan',
    socketUrl: 'wss://aibdev.gnx.sh/',
    socketLogin: 'https://aibdev.gnx.sh/api/v1/user/login',

    sortAssetList: [
        'user',
        'button',
        'background',
        'forextraction',
        'gif',
        'icon',
        'image',
        'lessontitle',
        'textboxes',
        'woodLandTreeCollection',
        'welbeingLeisureCollection',
        'waetherCollection',
        'waterColourForestCollection',
        'vegetablesCharacters',
        'thinkGreenCollection',
        'storeFrontCollection',
        'sationaryCollection',
        'sportCollection',
        'spaceElementsCollection',
        'scienceCollection',
        'rockandMountainCollection',
        'plantCollection',
        'paraAbilityCollection',
        'outerSpaceCollection',
        'notepadCollection',
        'multiCulturalPeopleCollection',
        'lwcollection',
        'healthyFoodCollection',
        'healthyDrinksCollection',
        'halloweenCollection',
        'grassandBushCollection',
        'gardenningandSpringCollection',
        'forestAnimalCollection',
        'financeCollection',
        'farmCollection',
        'famousLandmarkCollection',
        'emojiCollection',
        'easterCollection',
        'earthDayCollection',
        'dinosaurCollection',
        'dentalCollection',
        'cuteMonsterCollection1',
        'cuteMonsterCollection2',
        'cuteAnimalCollection2',
        'cuteanimalCollection',
        'cloudCollection',
        'classroomCollection',
        'cityscapeCollection',
        'chritmasCollection',
        'birdCollection',
        'bannerCollection',
        'autumnLeavesCollection',
        'animalAvatarCollection',
        'alienCollection',
        'africaCollection',
        'abstractGraffitiStickerCollection',
        'winterIcons',
        'weahterIcons',
        'tropicalIcons',
        'transportIcons',
        'threeWiseMenIcons',
        'summerIcons',
        'stationaryIcons',
        'springIcons',
        'sealifeIcons',
        'receptionnIcons',
        'LGBTQIcons',
        'internationalMovementsIcons',
        'historyIcons',
        'fineArtsIcons',
        'farmIcons',
        'familiesIcons',
        'fairIcons',
        'environmentIcons',
        'egyptIcons',
        'eductionIcons',
        'ecologyIcons',
        'easterIcons',
        'diwaliIcons',
        'cityIcons',
        'christmasIcons1',
        'christmasIcons2',
        'birthdayIcons',
        'autumnIcons1',
        'autumnIcons2',
        'animalsIcons',
        'woodenPlanks',
        'vegetables',
        'teacherDoodles',
        'sunIllustration',
        'summerTime',
        'socialMedia',
        'seaAnimals',
        'science',
        'safety',
        'medieval',
        'lawandOrder',
        'knights',
        'happyStudents',
        'halloween',
        'girlyDoodles',
        'environment',
        'earthDay',
        'dinosaurs',
        'dental',
        'culturalWomen',
        'circus',
        'christmas',
        'characters',
        'cartoonMonesters',
        'cartoonAnimals',
        'partyCollection',
        'petIconCollection',
        'petsCollection',
    ],
    display: ['none', 'block'],
    textalign: ['center', 'left', 'right', 'justify'],
    borderstyle: ['dotted', 'dashed', 'solid', 'double', 'groove', 'ridge', 'inset', 'outset', 'none', 'hidden'],
    callList: ['switchsld', 'show', 'hide', 'addClass'],
    typeList: ['click', 'hover', 'mousedown', 'mouseup'],
    paramList: ['sld1', 'sld2', 'sld3', 'sld4', 'sld5', 'sld6', 'sld7', 'sld8', 'sld9', 'sld10', 'sld11', 'sld12'],
    animationList: [
        'bounce',
        'flash',
        'pulse',
        'rubberBand',
        'shakeX',
        'shakeY',
        'headShake',
        'swing',
        'tada',
        'wobble',
        'jello',
        'heartBeat',
        'backInDown',
        'backInLeft',
        'backInRight',
        'backInUp',
        'backOutDown',
        'backOutLeft',
        'backOutRight',
        'backOutUp',
        'bounceIn',
        'bounceInDown',
        'bounceInLeft',
        'fbounceInRight',
        'bounceInUp',
        'bounceOut',
        'bounceOutDown',
        'bounceOutLeft',
        'bounceOutRight',
        'bounceOutUp',
        'fadeIn',
        'fadeInDown',
        'fadeInDownBig',
        'fadeInLeft',
        'fadeInLeftBig',
        'fadeInRight',
        'fadeInRightBig',
        'fadeInUp',
        'fadeInUpBig',
        'fadeInTopLeft',
        'fadeInTopRight',
        'fadeInBottomLeft',
        'fadeInBottomRight',
        'fadeOut',
        'fadeOutDown',
        'fadeOutDownBig',
        'fadeOutLeft',
        'fadeOutLeftBig',
        'fadeOutRight',
        'fadeOutRightBig',
        'fadeOutUp',
        ' fadeOutUpBig',
        'fadeOutTopLeft',
        'fadeOutTopRight',
        'fadeOutBottomRight',
        'fadeOutBottomLeft',
        'flip',
        'flipInX',
        'flipInY',
        'flipOutX',
        'flipOutY',
        'lightSpeedInRight',
        'lightSpeedInLeft',
        'lightSpeedOutRight',
        'lightSpeedOutLeft',
        'rotateIn',
        'rotateInDownLeft',
        'rotateInDownRight',
        'rotateInUpLeft',
        'rotateInUpRight',
        'rotateOut',
        'rotateOutDownLeft',
        'rotateOutDownRight',
        'rotateOutUpLeft',
        'rotateOutUpRight',
        'hinge',
        'jackInTheBox',
        'rollIn',
        'rollOut',
        'zoomIn',
        'zoomInDown',
        'zoomInLeft',
        'zoomInRight',
        'zoomInUp',
        'zoomOut',
        'zoomOutDown',
        'zoomOutLeft',
        'zoomOutRight',
        'zoomOutUp',
        'slideInDown',
        'slideInLeft',
        'slideInRight',
        'slideInUp',
        'slideOutDown',
        'slideOutLeft',
        'slideOutRight',
        'slideOutUp',
    ],

    slideColor: {
        id: sldid,
        // name: sldid,
        Meta: {
            Name: 'sld1',
            Background: {},
        },
        style: {
            'background-color': '#ffffff',
        },
        elements: [],
    },
    slideImage: {
        id: sldid,
        // name: sldid,
        Meta: {
            Name: 'sld2',
            Background: {},
        },
        style: {
            'background-image':
                'url("https://img.freepik.com/free-vector/empty-park-scene-with-river-simple-style_1308-61755.jpg?w=1380&t=st=1648044092~exp=1648044692~hmac=a53a040c484afa57d976f1cef9376b399fe0e32e4a158c62a0a32ed9799f076c")',

            'object-fit': 'cover',
        },
        elements: [],
    },
    elemButton: {
        id: elemid,
        name: elemid,
        icon: '<svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg"><g opacity="0.6"><path d="M8.22074 3.16566L11.6261 4.4218L10.8349 5.17843L11.7956 6.09708L11.5412 6.34001L11.2868 6.58319L10.3259 5.6649L9.53466 6.42113L8.22079 3.16562L8.22074 3.16566ZM8.22079 2.65655C8.08219 2.65655 7.94589 2.70841 7.84429 2.80556C7.69517 2.94785 7.64821 3.16085 7.72391 3.3488L9.03765 6.60431C9.10242 6.76506 9.24817 6.88362 9.42427 6.91909C9.46084 6.92645 9.49781 6.92993 9.53452 6.92993C9.6742 6.92993 9.81023 6.87729 9.91102 6.7808L10.3259 6.38448L10.9103 6.94309C11.0144 7.04229 11.1507 7.09209 11.2868 7.09209C11.423 7.09209 11.5593 7.04242 11.6633 6.94296L11.9177 6.69978L12.1724 6.4566C12.3802 6.25754 12.3802 5.93541 12.1722 5.73686L11.5879 5.17812L12.0027 4.78181C12.1301 4.65977 12.1842 4.48484 12.1469 4.31661C12.1098 4.14812 11.986 4.00918 11.8179 3.94701L8.41253 2.69073C8.35031 2.66777 8.28527 2.65654 8.22076 2.65654L8.22079 2.65655ZM12.125 0.117676H1.80949C1.32652 0.117676 0.935547 0.491927 0.935547 0.9534V4.29597C0.935547 4.75744 1.32648 5.13169 1.80949 5.13169H8.15826L7.95273 4.62263H1.80952C1.62126 4.62263 1.46796 4.47608 1.46796 4.29598V0.953413C1.46796 0.77319 1.62113 0.626766 1.80952 0.626766H12.125C12.3135 0.626766 12.4666 0.773319 12.4666 0.953413V4.29598C12.4666 4.35184 12.4506 4.40383 12.4245 4.44989C12.4173 4.64005 12.3359 4.82298 12.191 4.96166L12.0131 5.13169H12.1251C12.6081 5.13169 12.9995 4.75744 12.9995 4.29597V0.9534C12.9988 0.492059 12.6075 0.117676 12.125 0.117676H12.125Z" fill="#505050"/></g></svg>',
        disable: false,

        style: {
            opacity: 0,
            backgroundColor: '#51b33b',
            'pointer-events': 'stroke',
            'border-width': 1,
            'border-style': 'solid',
            'border-color': '#fff',
            'border-radius': 3,
            color: '#fff',
            'font-family': 'Roboto, "Helvetica Neue", sans-serif',
            'font-size': 12,
            'text-align': 'center',
            display: 'block',
            'z-index': 1,
            position: 'absolute',
        },
        position: {
            top: 1,
            left: 30,
            x: 10,
            y: 10,
            width: 40,
            height: 40,
        },
        content: {
            text: 'Button',
        },
        styleClasses: [],
        type: 'button',
        event: [
            {
                call: '',
                type: '',
                param: '',
            },
            {
                call: '',
                type: '',
                param: '',
            },
            {
                call: '',
                type: '',
                param: '',
            },
            {
                call: '',
                type: '',
                param: '',
            },
            {
                call: '',
                type: '',
                param: '',
            },
        ],
    },
    elemText: {
        id: elemid,
        name: elemid,
        icon: '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.6" d="M0 1.02009V2.52232C0 2.65653 0.0762491 2.78051 0.2 2.84757C0.323751 2.91464 0.476252 2.91464 0.6 2.84757C0.723749 2.78051 0.8 2.65653 0.8 2.52232V1.39565H5.6V10.409H4.4C4.25705 10.409 4.12501 10.4806 4.05358 10.5968C3.98215 10.713 3.98215 10.8562 4.05358 10.9724C4.12501 11.0886 4.25706 11.1601 4.4 11.1601H7.6C7.74295 11.1601 7.87499 11.0886 7.94642 10.9724C8.01785 10.8562 8.01785 10.713 7.94642 10.5968C7.87499 10.4806 7.74294 10.409 7.6 10.409H6.4V1.39565H11.2V2.52232C11.2 2.65653 11.2762 2.78051 11.4 2.84757C11.5238 2.91464 11.6763 2.91464 11.8 2.84757C11.9237 2.78051 12 2.65653 12 2.52232V1.02009C12 0.9205 11.9579 0.824932 11.8829 0.754516C11.8079 0.6841 11.7061 0.644531 11.6 0.644531H0.400001C0.293929 0.644531 0.192142 0.6841 0.117143 0.754516C0.0421438 0.824932 0 0.9205 0 1.02009Z" fill="#505050"/></svg>',
        style: {
            opacity: 1,
            backgroundColor: 'rgba(59,129,179,0)',
            'pointer-events': 'stroke',

            'border-width': 0,
            'border-style': 'solid',
            'border-color': '#fff',
            'border-radius': 3,
            color: '#17375e',
            'font-family': 'Roboto, "Helvetica Neue", sans-serif',
            'font-size': 36,
            'font-weight': 400,
            'text-align': 'center',
            display: 'block',
            'z-index': 1,
            position: 'absolute',
        },
        disable: false,

        position: {
            top: 1,
            left: 20,
            x: 10,
            y: 10,
            width: 40,
            height: 15,
        },
        content: {
            text: 'Lenny Goes to India',
        },
        styleClasses: [],
        type: 'text',
        event: [
            {
                call: '',
                type: '',
                param: '',
            },
            {
                call: '',
                type: '',
                param: '',
            },
            {
                call: '',
                type: '',
                param: '',
            },
            {
                call: '',
                type: '',
                param: '',
            },
            {
                call: '',
                type: '',
                param: '',
            },
        ],
    },
    elemComplexText: {
        id: elemid,
        name: elemid,
        icon: '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.6" d="M0 1.02009V2.52232C0 2.65653 0.0762491 2.78051 0.2 2.84757C0.323751 2.91464 0.476252 2.91464 0.6 2.84757C0.723749 2.78051 0.8 2.65653 0.8 2.52232V1.39565H5.6V10.409H4.4C4.25705 10.409 4.12501 10.4806 4.05358 10.5968C3.98215 10.713 3.98215 10.8562 4.05358 10.9724C4.12501 11.0886 4.25706 11.1601 4.4 11.1601H7.6C7.74295 11.1601 7.87499 11.0886 7.94642 10.9724C8.01785 10.8562 8.01785 10.713 7.94642 10.5968C7.87499 10.4806 7.74294 10.409 7.6 10.409H6.4V1.39565H11.2V2.52232C11.2 2.65653 11.2762 2.78051 11.4 2.84757C11.5238 2.91464 11.6763 2.91464 11.8 2.84757C11.9237 2.78051 12 2.65653 12 2.52232V1.02009C12 0.9205 11.9579 0.824932 11.8829 0.754516C11.8079 0.6841 11.7061 0.644531 11.6 0.644531H0.400001C0.293929 0.644531 0.192142 0.6841 0.117143 0.754516C0.0421438 0.824932 0 0.9205 0 1.02009Z" fill="#505050"/></svg>',
        style: {
            opacity: 1,
            backgroundColor: 'rgba(59,129,179,0)',
            'pointer-events': 'stroke',

            'border-width': 0,
            'border-style': 'solid',
            'border-color': '#fff',
            'border-radius': 3,
            color: '#17375e',
            'font-family': 'Roboto, "Helvetica Neue", sans-serif',
            'font-size': 36,
            'font-weight': 400,
            'text-align': 'center',
            display: 'block',
            'z-index': 1,
            position: 'absolute',
        },
        disable: false,

        position: {
            top: 1,
            left: 20,
            x: 10,
            y: 10,
            width: 40,
            height: 15,
        },
        content: {
            text: 'Lenny Goes to India',
        },
        styleClasses: [],
        type: 'complex_text',
        event: [
            {
                call: '',
                type: '',
                param: '',
            },
            {
                call: '',
                type: '',
                param: '',
            },
            {
                call: '',
                type: '',
                param: '',
            },
            {
                call: '',
                type: '',
                param: '',
            },
            {
                call: '',
                type: '',
                param: '',
            },
        ],
    },
    elemImg: {
        id: elemid,
        name: elemid,
        icon: '<svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.5" d="M13.6405 0.180176H1.35946C0.99221 0.188533 0.643814 0.31941 0.389353 0.544531C0.134893 0.769652 -0.00489399 1.07104 0.00013093 1.38314V8.55288C-7.83166e-05 8.86229 0.142007 9.15942 0.39584 9.38116C0.649883 9.60273 0.995564 9.73147 1.35947 9.73982H13.6405C14.0078 9.73147 14.3562 9.60059 14.6106 9.37547C14.8651 9.15035 15.0049 8.84896 14.9999 8.53686V1.36712C15.0001 1.05771 14.858 0.760579 14.6042 0.538841C14.3501 0.317275 14.0044 0.188534 13.6405 0.180176ZM1.35946 0.976814H13.6405C13.8942 0.976814 14.0999 1.15161 14.0999 1.36713V7.88363L10.7718 4.27495C10.6734 4.17288 10.5238 4.11669 10.3687 4.12363C10.2124 4.13252 10.0716 4.20738 9.99375 4.32279L8.75616 6.14704L5.74678 2.96049C5.65136 2.8698 5.51513 2.8177 5.37179 2.81717C5.22509 2.81894 5.08865 2.88136 5.00621 2.9845L0.937574 7.84399V1.38303C0.926692 1.1732 1.11314 0.993598 1.35944 0.976705L1.35946 0.976814ZM1.35946 8.94319C1.29146 8.94124 1.22449 8.92772 1.16255 8.90336L5.40925 3.94054L8.46551 7.12709C8.55759 7.23076 8.70742 7.28535 8.85934 7.27041C9.01377 7.26312 9.15419 7.19163 9.23434 7.07925L10.4625 5.26301L13.828 8.91152C13.7663 8.92343 13.7022 8.92343 13.6405 8.91152L1.35946 8.94319ZM11.4002 2.41076C11.4002 2.19951 11.499 1.99679 11.6748 1.84743C11.8505 1.69806 12.0891 1.61412 12.3377 1.61412C12.5863 1.61412 12.8246 1.69806 13.0006 1.84743C13.1764 1.99679 13.2752 2.19951 13.2752 2.41076C13.2752 2.62201 13.1764 2.82473 13.0006 2.9741C12.8246 3.12347 12.5863 3.2074 12.3377 3.2074C12.0891 3.2074 11.8505 3.12347 11.6748 2.9741C11.499 2.82473 11.4002 2.62201 11.4002 2.41076Z" fill="#505050"/></svg>',
        style: {
            opacity: 1,
            // "backgroundColor": "#3b81b3",
            'pointer-events': 'stroke',

            'border-width': 0,
            'border-style': 'solid',
            'border-color': '#fff',
            'border-radius': 3,
            color: '#fff',
            'font-family': 'Roboto, "Helvetica Neue", sans-serif',
            'font-size': 12,
            'text-align': 'center',
            display: 'block',
            'z-index': 1,
            position: 'absolute',
        },
        disable: false,
        position: {
            top: 1,
            left: 30,
            right: 10,
            bottom: 20,
            x: 10,
            y: 10,

            width: 25,
            height: 20,
        },
        content: {
            src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABK4AAAEYBAMAAACHH6ODAAAAD1BMVEUpagAqawAqagAkWQArawAje/ySAAAABHRSTlMA2Rt4xiNasQAAFelJREFUeNrtnWl6ozAMhilcICwHYMkB2C5A4P5nmqZNpiEBW4ttDEg/55lQEK8+ybKxg0BMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMbL8Wdk2cTdM0xF0r3vi1qovjb5dMcdrl4g0aVT8O/LW4FS+++ySVYKO4sMmmFxtSAevbJ9PMJyJZXBfewzMXn7y5ZEgEFKR9YPUNlmD1boOkQpwVn1id3onNkk9qYQVhUTYtOfHUmbBacsnpRRxn/aIPpzOXE2G27BPJhAi5WnbhqQWrWPHJKGNCrlydWbDW5EoEiy9XZxasdZ+MAgxT8s8cnP26T2RIyJX88wZnuO6SSZqjXMk/byL8UvlEkOGmwdMmwl7lE0mEfB/ezumTbJJEaLG8Omu7RlUayIjQhA/PWWB9qX0i0ACsUvrwnMVEIbFm2YfnLCZ6iTXbPhSuPu0i1LB9eMYiVT2UkQGhCR+ekatIfGKdqzMOftRDZOHKhA+FK+HKCle5+OTMsVaCzBZX35euuq5rF//E0Vovp+IqBliW4Lma9FyVXRPH0/Bt0xAf4YNz4erPJoiNBK50TcCqid9+EddH5yoXrnSNFyZXZZMdz+/ClX2ulF9ihlV2xMahcOWAK4UPw+aYBYjUV5tyVfUuZ2ZzzChXuNovV5Grb1Z+WhjdfdC5bNidb8KqfQAZhsLVVlyhk6DpAquKY7PlTpP9IflDbPcme4X02zfjSomVUa76yWwZ/fnED84eiMk8jgmuQqIPG1ee1zZCsFypOB2G+95puj+ZCld6rmhrQqrMFVdfhrnSQXPT/5dEuNJz1WvdHBij0cbgDMtVpedK1vXxuaKtQ3ZY2eq5mnKT10v0XNXClR6SguBD3YJKk1w1+sdCvecrwEfy3cQ2XGmHaJtyFSpbpjquLoF852WCK8J3qfohmts8OOeq7F57ph+rdnQx0WrHCqdaLkrmSvMdPUmutuTqfSCSIm++1gZOIlxBPNKbVbituSo0W+JAuFLv+1ELV5BdhwqsD3ufufqU3xHVIfkdXF6lvGJzhd1XTftmNuUq0jwDjKtIyis2Vyr9GWkv2m2/fcZVYYQr1f9KhCtYZVAYT4MbctXrynpY874w1IU9s16tB+dSGowmn7kKdVwB15vJPtt8vVoPTkIfdWuuMs1TaNfA5BpVboUrKFdrgrU48skccxWhHiuauFw9/1+m5k64AnReCqPNK9+4umHkb9T45Gx7qrG4Wp6EWwzNwm+uCt3NgLlaXkB0unPieFwtZcKBNuW8AVcv++dddTcDX+ETHfCLW9dcLThx+bjUMPObq163RF/H1U3pk/PtLMrkKqjeUuHQUd+ye64SNfYzkSnA11rwyQlP3+ByFYSznRbiljyrYpirEMWVdljbI7h6230iLQPhCj+YCaunF4e4W3Nh756rDMFVROnHK8bA3z6Jf/9+nLZ5IFyRpiAeHxZ3bcl4yZvq1Rebq3edDsvu/3eFwhV5aivPc+ZL3lSvrmyuarxThCu2e4Blu8k2D4qrXpvbMk6pIFxZWpEGLNuNriXBcKXdjisUrnzUq95vrlaoGYUrv/Uq9JOrmyZNI7hidz7L8qfQb9uyzIUrc7XOpnoVadcghDZddB9PP/sS0/0bs7YUrgyN+c1z1cP1qtA+t8VjEO7bjb9fLe1K4crccFDDVflslIH2cER8rdho60prXIVdvCisMZyssCyf/UN/cqgTrqDDQdUJfWHV/d+Ab7jnitwcV722GLfFVbX+uX8MOyjh93SFZw7tfBG6vXD1cYxAnLamuFot/+BcEZeDdsoiMNXPV38H2weO7Wm4unK5ChePEVD73QBXF3Bk0CYKGt0oU4dIt7SF6pC2J+EK2mZY26G4WtmBdlBtaQznKtKXe1a4augeeUTb2gvrhKvXMMvhYqVZlwMSSS1XN6tcNZxQC9R7am6+NofMVdQpDd2+WhVv9Q7K66kCzlWhp0V3sfQ5ulNYSyo6Vys39VatW68lpHMF9waAq3XlDhviL+FcNXyuHhnzC7hUOQDsXahRrIpbm+2TK1xbdN0JoT5btFyuVtP0AM7kEK4S0tTWyiKPKqP71BeuRqZeRQwXALLFyq/BXEH2AzDOFbj1sly7QUoLdlnsI1eodvs6VhVIT2sakVquJmtcgWdMl7mCqd2W31j7oFcjd8Ka+CXsqL29GjqJ3SK5QsjV0uRWQ/6lV1wFPL0qyHLV0F0P2Phj1N4emKsaxxVGrhaaxRX05/X+uKrgClJQ64AK6vqlTAg4yER7excoB0iuMHL1CQecyu0yoQd6NTKz4MpgHMxVr0fBMFcoufrkqmDl0OPolWZkdmNPVy/mUvCBXoD9LCPQLpBgriIMVh9yjqFyszGhC7260mIqyjjeB3Olek0j8FoDjqsexRUn3DYTLFtc5fDpwYRZtK9cBcoVZA9js1zh0uDIkKvtBMuFXtGOI8L579OBJrgarHCFSoMfZQJKrjYTLBd6RTs+Dem/j+E4lKuCywuaK5YQI8Ntq8PKHegV7Vg+rP8+xtRQrq6A/gV0tz4YVxknXrDhttGGud7qFdp/H8e+AbnqAdcsTHIVZYzHQofbRht8u9ArUlO4n5gOBHIVZs65wj1WjlRhPyp3y3r18w0ShSu8/94dCOUKcm+9Sa4KzlPhw22byt2qXoX3b5C0wn0xkwY/MgbslYHODITuqgbiCofGvGzEp8GNEqFVvYJVEomJqv3zPvWX+OHqy3eu2OG2yck8lA4KWK8isk5HFP8NOYGrAvJWM4NcIUPmxk2D2yRCW1wh9Cpd+LDgSvHf2wlceq5q7ZsCcnVBcBUxoCDJ+CaJkMw7SK8y6vOT/Id+B7X2L42o5Qw2uKrZMr7JiNAWVznBDSPTf29fa/QQvdIgo5+aRnNVMLiiyfgWy/v81KuC5r95hdpD/B1BQj3ajqu51tBkfIsCy0+96icDgWmQq8kgVz2dK6KMb1FgWdWrkPj4ITEu5yMMEFcFRAHBuxSZ5wp1qNjq/R1Nr4h5kBqXqOU5v1yB9mU3yVWY2XwibwosL+srank1L7AcchVY4yoxUF4diauckwfJcYk6IuL+v0NQx7MwyRX9gcgyvkHhbre+oukVubyazzW642r0navxYHpF40qZPoc4VvXukVxFk2uucHDMhoPK2xji7BhcZdb0SuX6tC3LDubAK4Ar7QgrxSyTscyV4jaGriyr3qOOu496VehupQA5UM/VRT9CGCFcpda4Aq7n/t1SR/Ef6t1wFdqrr9Zf4/Oz5l41NQMfVV70uRLEVYLgqrLA1XOnpvUc4iVXLSEPcvQq01ITQQITwhVsLY1JrnC9zQSUIVLtlz6Jj1zVbvVq/VeAiZ4LiivYGi3tDPbFNFfZkusL/QuKDs8VQ68gYlQAHAjgCvYtWJgZ5ArQ84277rExO2w4OOpT5bgfrqyNByNAUR4BChIAV1+gh4cfPmhCr4af80t+NxdPQLM4if7/DKJXkLgEBaa+Qk4bGFeTQa60c0LPavZbsma7L4WQorzwpdHgoV71kMFRz9C0hTpG+fCRS67+Bknl/AyldWfm+hUPh+Eqt8BVYpwr2IgMfpgXn6v1hAUpD9b/U316vQohYz2I4O+Sq/UCu2L1uOrT6xWojlgvwmrDXN30hZpJrlY3LwSVnZCjyU6rV6D7iFxxNSKWyRhYz7DeaAKVnauN3uT0egWqI7ziavSIq/7gXAXmuZpAXCWGuRpMc5XR8iBkFkLB1Xh6vSp4emWcq9wsV7APrIUrpfRsyhVj2elcJXXTgzcXXEWTcMX6HucK4mq1TElNc3WBL2cAcXUFTFSY52o4lF5NBK56DVfl3apO72VDXN0Mc1UAexZIrsK7W9qux153l3pllqtvmr6tib9tmJxxNcCXyZjY96PGtq+m8dcvard4yNXgVK8U11V+MWGNq6kGL2eA7X9FazSsp88hzqgvcX9c5Ra4QoieSa5Sw1xlwPsHtq+g0eEfV7knerURV4hXZmIfyFq4sqJXkzGuekdc5TiuaMfmCVc8veJ2M1/u1hFXA5KriERAJlyx9Or4XOny82ILi53UW9GrvXEV4LhC9MOgy74Blpxcr752x9WI5Uq77qbGtEXPxVUgXK2+We301kImFK6YelUcnyv9jaXClVKvMuFq6c3qn7E1ztXtQHoVbsDVy4C6ccNVguYK8Jn1O1hfBunfvV5tzFXhK1cAJX0H64hcBVS9ouwp3e+OqwueK0BWexsUClevT3EVrha5ggj57CN6/rMcSq9A1ebQPCzdJ1c1nivQraXn5KoHPAVo6ncM8oedhytQ5dka5Sr3jauRwtXjKSLAmrPR6Lz9PrgC3dsrCuxnGY7B1f//VnXNwbnKKVyBBCuBLBc9F1c5fPCzc64GElegm3u5dCNcvf9mM64qn7lCCpZwtbVetebmPmxyhRQs/tzBTrgKLOkVe1F64pirMaBxBRorJ6fjypZenYYrUJoezXFVn1qvwt1xdaNyBRKs2tR48CBc5cKVjivQ/aXGxraH06sQdX0uV7FrrhIyV5AxyrNy53IVx4fTq9CVXg1x3L3uTR1lnnMVwWWmYDGVzrfsFr1CMJV2784LnehVS+cKUo3feFz9hFoeODff9IrC1Z2pdsF5bj6krxlcReDZ04Io320ZbGLe6VWPd167EpD+cxU00OsXBKbKjZgCcpU61avenMjvgCuAYF2w60WHrXLfIfQK4Dw3XOUcrgCPe0Nx9VNmbszUbvVqgIm8E64GHlcRMKy/YEy1PjAF5CrxSq9+nAcrHPbAlT6Ofv+A9oweuFt2zZUVvfp2XolwHpargcLhyORKX5DXWq48Y8qVXmWmuLrhRB67sdqNskZndvcErvTwJ1quPGNqd3ql+qYkJBXF85HXdQOu9IJ103KlCrdc9Erb0VFx1dRsrupiC65C0F8Ioa2O93FB6i9X5YvlOV6vUFwVNK6qpdeG42rIKRPVCZcr7V3+FO5ErsJ+yH3lasr+2+sMpiW9KqBjr/dSauByNZImFPlcFRCulPNb64dWFu5PtIRztSxFG+jVeiHRLEZtjySEsoMynyvYseQZ4co/7fxxJ1yBzqWi69UXRfCr5SyJw6QmfbRRs7kKQecOUMYzv3FS74SrRzaypFdfE17wf2fZPrMkDpOctGqAz1UAOn9H2ddbwapR/13PuHrcqCW9ivBTlc8/kBBWC8zDJfKSq58fXvE6Xix0bn3mSnNO4MezmONqUITlAnVX7FMRZn4McFWwuVq8dJXp2xAecrWFXi25KGxWy3pUWrsROl7vydciVwVWx/9jtUki9E6v1BSmyqVxCYerBJ05XXE1UuLtDyvnZw/a5IqsV+r//bllfrNGM5arGv0Lj7hKFVhtkght5UFLevWOTtmowrZAA4Iu3IfAEVeanu18m9twhtUWLSwHeoXjSlfiJPmq+0hba8zvAl24jwa46kFcqe9sKNejbYtE6F19pfVy97x0WTWaiR48V8EGXEUgTdRWE+3/YOsyMNIn0ittc+BncV/VdbG2fsVsTp0QWl5muOpBXOmnp++L+8quazJ4Q/5MegVoOt2PXs/YPYtFIrGFe8LmSr+tDIyrnw9x1o5Wr0WvWDsRzBMhgqvnQDNyzVWVAbli+SURveLt1pFQuYJOAhvmCoCVCa7G/XBVWNIrHlcj8VIj8Gb5XJV/n2KVCyX2Klc8v9QH4YquV7yvs2aN04jAR895XwCuwvjVEP42qOMH0aveIVczByJexYUyhqRwFVH9zYy3/Hh6heOKuSMyZqfAJT4i23q1DVeuE6F/esXdSrN+X++HC+eQIwM2ueLG2w64yq3qFXPLw4TC1QiuBjfgKjXhF8eJ0EO9Ym4L+uLAkMLV1TuuEtPxdk694m7XUROudCHKJYGrjEoEM97GQ3AVbMfVjXClmiiXb/duh6uLEb+4TYQe6hX3iJyXGjwj+Bz1+pxwVZuJt+TkesXeq7xG1+ADFWuXXHHjbTy7XnH387+huRoNcRXZ4Oq/mJqLt3PqFVfw/7JahiYR+foSPFf0T3648ZacXK/YZxCiuaqpconnCv9wo6l4G0+uV+xD0XIsoDlVLi8uuQqEK55eGeuM9tgfYDNV7YCrxJSOn16vuJ0a7IsYyWnYBVcX0np9qa/GwHCBNWKvcyP3OVxw9TJ/wOOqPbteMUfU6MSRkNOwA65ek/R+lmD5qVe8AivHclVT0/D7q7LClaklRIfoi/L0ipUIR+zA8p0OeOHugqvRVLzVwen1ipUIW2x8fySInqIlUK6wmnMxNKA5xrwzU68iM/4raAmi8Imr2pCO72D9VWBdrxgOTNCAJGSqRwJXBUdmop3Ila96RU+Esw+9YFdpyf0zB1yNxCHFuzk+d8LT+oruwBS8bkVR0HrEVWIo3upA9IozR1ijuVrIENAsfLPP1XuHLNuFXHmhV4uZPzLhvy+K6CDefWKdK0OLaYc6EL1iOHCojXAFhfpC4KpCPVBiJt6cn+rlrV7RHJgGeK4WBuChRa5wz1UbiTfHg0FP9Co3Jlio/reqos1ob904V4bmuHayD6QTvaI4sCVcYjGWe0+4SozE2wYnmXisV/ghYUpBc2C0z2xztcg8ekg47GX/djd6hT9PPqdwNTK0MrfMVWIk3nZzjkmuHdcY0Svk0Glh3VpE9XroBVcrQoOMt/2c5wXgyoReIb+JSmmyc6G/uoHCFYKK1ES8DXs51/IBQmRfr1CRuXQZiOzU9MGoZa5WuwNhw1LxPXOF0CtVc6XKWGEZkl9eQULZLFfrdRFCyDc5LdULvVI27aCzHkNLLJNGRpMDtwMAlitVXQQeE6Z5cFa9UteVDQMryDu8rSjC5lyp6yKgkG+FlRO9unK4AtUSq+9A7/0LI9PcKFwB+5qDpi4CgbUZVoz1osq4m7FyJWUiBFjxamjrnV8zEjCNK+IiVgJY22FF4mrQxx1KrwImWOl6xtCflcVpyiao7Jkgrjx0+lenAwtyDWvWUUwfdzO9KpiRGSpP+xg6RVRe6bIAkBXcYoMErjQxqDlQNfxr2LKSYLle9DHH1AD6dlWscJ9K7COqXN1lMsP/OAIhrAFrSEvgy1u/RfA1PLQGqFchf5phzYNxV7JyqCqmw+pXnZvnYTYZoB3egKqxqosVVLXgsihckyzENfyzcD1TpqDscH9ZaQ31YLZElc594YOKdHZ7P/84DXGn+Xn4bS9C/fj1g7HFqljhk1eGw7JbPJlzuB8Gi8o3XbNE5n7F6tX1n7bWxft7w9U8qQL+UDkPcqD3nlzkM3v8I+mJnz9e/XW+Yu8VSPfGVoyF6vc6bxEHCLbD2G+k/75fRih9v4rmLhVxfL/Y/r0X/mlgdz+dOadeprpr6HSP2ba0IlX/AC9bsQmp+YkMAAAAAElFTkSuQmCC',
        },
        styleClasses: [],
        type: 'img',
        event: [
            {
                call: '',
                type: '',
                param: '',
            },
            {
                call: '',
                type: '',
                param: '',
            },
            {
                call: '',
                type: '',
                param: '',
            },
            {
                call: '',
                type: '',
                param: '',
            },
            {
                call: '',
                type: '',
                param: '',
            },
        ],
    },
    elemSvg: {
        id: elemid,
        name: elemid,
        icon: '<svg width="18" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" class="" tabindex="0"><path d="M9.00798 0.632069C4.0605 0.632069 0.0319824 4.66049 0.0319824 9.60807C0.0319824 14.2808 3.62476 18.1367 8.19198 18.5501V23.7521L8.19217 23.7519C8.19217 23.9684 8.27812 24.1759 8.43104 24.3289C8.58416 24.482 8.79173 24.5679 9.00802 24.5679H23.152C23.3683 24.5679 23.5759 24.482 23.729 24.3289C23.8819 24.1759 23.9679 23.9684 23.9679 23.7519V9.60788C23.9679 9.3914 23.8819 9.18383 23.729 9.0309C23.5759 8.87779 23.3683 8.79184 23.152 8.79184H17.95C17.5332 4.22763 13.6786 0.631836 9.00802 0.631836L9.00798 0.632069ZM9.00798 2.26417C13.0736 2.26417 16.352 5.54255 16.352 9.60817C16.352 13.6738 13.0736 16.9522 9.00798 16.9522C4.94241 16.9522 1.66398 13.6738 1.66398 9.60817C1.66398 5.54255 4.94236 2.26417 9.00798 2.26417V2.26417ZM17.95 10.4242H22.336V22.9362H9.82403V18.5501C14.1234 18.1608 17.5615 14.7236 17.95 10.4241L17.95 10.4242Z" fill="#505050"></path></svg>',
        style: {
            opacity: 1,
            // "backgroundColor": "#3b81b3",
            'pointer-events': 'stroke',

            'border-width': 0,
            'border-style': 'solid',
            'border-color': '#fff',
            'border-radius': 3,
            color: '#fff',
            'font-family': 'Roboto, "Helvetica Neue", sans-serif',
            'font-size': 12,
            'text-align': 'center',
            display: 'block',
            'z-index': 1,
            position: 'absolute',
        },
        disable: false,

        position: {
            top: 1,
            left: 30,
            x: 10,
            y: 10,
            right: 10,
            bottom: 20,
            width: 26,
            height: 26,
        },
        content: {
            d: 'M18.7999 15.3819H18V1.70612C18 1.30347 17.7308 0.975699 17.4 0.975699H2.60003C2.26925 0.975699 1.99999 1.30346 1.99999 1.70612V15.3819H1.20007V1.70612C1.20007 0.766325 1.82828 0.00195312 2.60003 0.00195312H17.4C18.1717 0.00195312 18.7999 0.766499 18.7999 1.70612V15.3819ZM16.7999 14.8529H20V15.8267H16.7999V14.8529ZM0 14.8529H14.1999V15.8267H0V14.8529ZM12.2185 8.69258L18.4278 19.4417L17.7734 20.002L11.5641 9.25284L12.2185 8.69258ZM4.99998 6.57524H14.9999V7.54898H4.99998V6.57524ZM4.99998 4.14066H14.9999V5.1144H4.99998V4.14066ZM4.99998 9.00982H9.19997V9.98356H4.99998V9.00982Z',
        },
        attributes: [],
        childrens: [],
        styleClasses: [],
        type: 'svg',
        event: [
            {
                call: '',
                type: '',
                param: '',
            },
            {
                call: '',
                type: '',
                param: '',
            },
            {
                call: '',
                type: '',
                param: '',
            },
            {
                call: '',
                type: '',
                param: '',
            },
            {
                call: '',
                type: '',
                param: '',
            },
        ],
    },
    elemVideo: {
        id: elemid,
        name: elemid,
        icon: '<svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.58684 1.54128L9.98091 3.95671L6.57427 6.37215C6.34804 6.5284 6.31024 6.82882 6.47369 7.04508C6.57427 7.17728 6.72508 7.23738 6.876 7.23738C6.97657 7.23738 7.08969 7.20133 7.17772 7.14123L11.1123 4.35327C11.2381 4.25712 11.3135 4.11295 11.3135 3.96868V3.94462V3.92056C11.3135 3.77638 11.2381 3.63213 11.1123 3.53597L7.19029 0.748007C6.96406 0.591759 6.64979 0.639872 6.48635 0.844154C6.31037 1.08465 6.36061 1.38507 6.58693 1.54132L6.58684 1.54128ZM-0.000176965 3.95671V3.93266C-0.000176965 3.78848 0.0752329 3.64423 0.200973 3.54807L4.13558 0.77212C4.36181 0.615872 4.67608 0.663986 4.83952 0.868268C5.00296 1.08453 4.95263 1.38496 4.73894 1.5412L1.3323 3.95664L4.72637 6.37207C4.9526 6.52832 4.9904 6.82874 4.82695 7.04501C4.72637 7.1772 4.57556 7.2373 4.42464 7.2373C4.32407 7.2373 4.21095 7.20126 4.12292 7.14115L0.200884 4.35319C0.0751416 4.25704 -0.000267391 4.11287 -0.000267391 3.9686C-0.000179711 3.96868 -0.000179705 3.96868 -0.000179705 3.9567L-0.000176965 3.95671Z" fill="#505050"/></svg>',
        style: {
            opacity: 1,
            backgroundColor: 'rgba(59,129,179,0)',
            'pointer-events': 'stroke',

            'border-width': 0,
            'border-style': 'solid',
            'border-color': '#fff',
            'border-radius': 3,
            color: '#17375e',
            'font-family': 'Roboto, "Helvetica Neue", sans-serif',
            'font-size': 36,
            'font-weight': 700,
            'text-align': 'center',
            display: 'block',
            'z-index': 1,
            position: 'absolute',
        },
        disable: false,

        position: {
            top: 1,
            left: 30,
            x: 10,
            y: 10,
            right: 10,
            bottom: 20,
            width: 38,
            height: 29,
        },
        content: {
            embed: '<iframe width="100%" height="100%" src="https://www.youtube.com/embed/-Wa86Y2HmHg" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullscreen></iframe>',
        },
        styleClasses: [],
        type: 'div',
        event: [
            {
                call: '',
                type: '',
                param: '',
            },
            {
                call: '',
                type: '',
                param: '',
            },
            {
                call: '',
                type: '',
                param: '',
            },
            {
                call: '',
                type: '',
                param: '',
            },
            {
                call: '',
                type: '',
                param: '',
            },
        ],
    },
    elemShapes: {
        id: elemid,
        name: elemid,
        icon: '<svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M12.8206 3.72866C12.8206 1.9765 11.4571 0.550781 9.78151 0.550781C8.10575 0.550781 6.74219 1.9764 6.74219 3.72866C6.74219 5.48092 8.10565 6.90627 9.78151 6.90627C11.4572 6.90627 12.8206 5.48086 12.8206 3.72866ZM7.30351 3.72866C7.30351 2.29987 8.41512 1.13759 9.78161 1.13759C11.1481 1.13759 12.2596 2.29987 12.2596 3.72866C12.2596 5.15734 11.148 6.31962 9.78161 6.31962C8.41522 6.31962 7.30351 5.15734 7.30351 3.72866Z" fill="#6D6D6D"/> <path d="M6.66893 6.32031H1.15161C0.99672 6.32031 0.871094 6.45177 0.871094 6.61361V12.3825C0.871094 12.5444 0.996822 12.6758 1.15161 12.6758H6.66893C6.82382 12.6758 6.94944 12.5443 6.94944 12.3825V6.61361C6.94944 6.45167 6.82391 6.32031 6.66893 6.32031ZM6.38842 12.0892H1.43242V6.90697H6.38842V12.0892Z" fill="#6D6D6D"/> <path d="M14.2445 6.55589C14.2429 6.5474 14.2397 6.53942 14.2374 6.53124C14.2345 6.52131 14.2325 6.51098 14.2286 6.50116C14.2248 6.49134 14.2195 6.48254 14.2146 6.47333C14.2107 6.46587 14.2074 6.45809 14.2028 6.45093C14.1824 6.4187 14.1559 6.39108 14.125 6.3695C14.1184 6.36479 14.1111 6.36172 14.1042 6.35763C14.0952 6.35231 14.0864 6.34658 14.0768 6.34249C14.0677 6.3385 14.0581 6.33635 14.0487 6.33338C14.0406 6.33093 14.0329 6.32755 14.0245 6.32591C13.9882 6.31845 13.951 6.31845 13.9146 6.32591C13.9062 6.32765 13.8985 6.33093 13.8903 6.33338C13.8809 6.33635 13.8714 6.3385 13.8623 6.34249C13.8528 6.34658 13.8439 6.35231 13.8349 6.35763C13.8278 6.36162 13.8206 6.36479 13.8141 6.3695C13.7987 6.38034 13.7841 6.39251 13.7711 6.40632L8.25423 12.1746C8.24122 12.1882 8.22938 12.2034 8.21921 12.2197C8.21471 12.2265 8.21167 12.2342 8.20786 12.2413C8.20297 12.2508 8.19749 12.26 8.19328 12.27C8.18966 12.2795 8.18741 12.2895 8.18457 12.2994C8.18222 12.3078 8.17909 12.3159 8.17723 12.3247C8.17009 12.3627 8.17009 12.4016 8.17723 12.4396C8.17909 12.4484 8.18212 12.4565 8.18457 12.465C8.18741 12.4748 8.18946 12.4848 8.19328 12.4943C8.19739 12.5043 8.20277 12.5136 8.20786 12.523C8.21167 12.5304 8.21471 12.5379 8.21921 12.5447C8.23966 12.5769 8.26617 12.6045 8.29709 12.6261C8.30365 12.6308 8.31099 12.634 8.31783 12.638C8.32684 12.6433 8.33564 12.6488 8.34523 12.6531C8.35433 12.6571 8.36392 12.6595 8.37331 12.6623C8.38143 12.665 8.38916 12.6681 8.39758 12.67C8.41568 12.6737 8.43417 12.6757 8.45257 12.6757H13.9696C14.1245 12.6757 14.2502 12.5443 14.2502 12.3824L14.2501 6.61333C14.25 6.59409 14.248 6.57476 14.2445 6.55583L14.2445 6.55589ZM9.12972 12.0888L13.689 7.32142V12.0888H9.12972Z" fill="#6D6D6D"/></svg>',
        style: {
            opacity: 1,
            backgroundColor: 'rgba(59,129,179,0)',
            'pointer-events': 'stroke',
            'border-width': 0,
            'border-style': 'solid',
            'border-color': '#fff',
            'border-radius': 3,
            color: '#17375e',
            'font-family': 'Roboto, "Helvetica Neue", sans-serif',
            'font-size': 36,
            'font-weight': 700,
            'text-align': 'center',
            display: 'block',
            'z-index': 1,
            position: 'absolute',
        },
        position: {
            top: 16,
            left: 6,
            width: 54,
            height: 50,
        },
        content: {
            icon: `<svg width="100" height="80" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.58684 1.54128L9.98091 3.95671L6.57427 6.37215C6.34804 6.5284 6.31024 6.82882 6.47369 7.04508C6.57427 7.17728 6.72508 7.23738 6.876 7.23738C6.97657 7.23738 7.08969 7.20133 7.17772 7.14123L11.1123 4.35327C11.2381 4.25712 11.3135 4.11295 11.3135 3.96868V3.94462V3.92056C11.3135 3.77638 11.2381 3.63213 11.1123 3.53597L7.19029 0.748007C6.96406 0.591759 6.64979 0.639872 6.48635 0.844154C6.31037 1.08465 6.36061 1.38507 6.58693 1.54132L6.58684 1.54128ZM-0.000176965 3.95671V3.93266C-0.000176965 3.78848 0.0752329 3.64423 0.200973 3.54807L4.13558 0.77212C4.36181 0.615872 4.67608 0.663986 4.83952 0.868268C5.00296 1.08453 4.95263 1.38496 4.73894 1.5412L1.3323 3.95664L4.72637 6.37207C4.9526 6.52832 4.9904 6.82874 4.82695 7.04501C4.72637 7.1772 4.57556 7.2373 4.42464 7.2373C4.32407 7.2373 4.21095 7.20126 4.12292 7.14115L0.200884 4.35319C0.0751416 4.25704 -0.000267391 4.11287 -0.000267391 3.9686C-0.000179711 3.96868 -0.000179705 3.96868 -0.000179705 3.9567L-0.000176965 3.95671Z" fill="#505050"/></svg>`,
        },
        styleClasses: [],
        type: 'shapes',
        event: [
            {
                call: '',
                type: '',
                param: '',
            },
            {
                call: '',
                type: '',
                param: '',
            },
            {
                call: '',
                type: '',
                param: '',
            },
            {
                call: '',
                type: '',
                param: '',
            },
            {
                call: '',
                type: '',
                param: '',
            },
        ],
    },
    initailProject: {
        afterinit: {},
        beforeinit: {},
        slides: [
            {
                id: 'sld1',

                Meta: {
                    Name: '1',
                    Background: {},
                },
                style: {
                    'background-color': '#ffffff',
                },
                elements: [],
            },
        ],
        meta: {
            Id: '',
            Name: '',
            size: {
                width: 948,
                height: 570,
            },
            style: {
                'background-color': '#FBFBFB',
            },
            Type: '',
            Legacy: {
                Lessonid: '',
                Masterid: '',
                Satus: '',
            },
            Studio: {
                Lessonid: '',
                Status: '',
                Cover: {
                    Elements: [
                        {
                            Id: '',
                            Type: 'img, button, div, question',
                            Content: {
                                Src: 'image url',
                            },
                            Position: {
                                Top: '',
                                Left: '',
                                Width: '',
                                Height: '',
                                right: '',
                                bottom: '',
                            },
                            Style: {
                                backgroundColor: '',
                                'border-Color': '',
                                'border - radius': '',
                                'border - style': '',
                                'border - width': '',
                                color: '',
                                display: '',
                                'font - family': '',
                                'font - size': '',
                                opacity: '',
                                'pointer - events': '',
                                position: '',
                                'text - align': '',
                                'z - index': '',
                            },
                            Event: [],
                        },
                    ],
                },
            },
        },
    },
};
export default appConfig;
